import Schema from './Schema'
import FieldHidden from'../fields/FieldHidden'
export default class SchemaHidden extends Schema {
  constructor(label, key, rules, options = {}, on = {}) {
    options.hide = true
    options.inTable = false
    options.editable = false
    options.asFilter = true
    options.asTabFilter = false
    super(options)
    FieldHidden.call(this, label, key, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaHidden.js